var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5703 120C82.4129 120 80.6641 118.251 80.6641 116.094C80.6641 100.801 68.2225 88.3594 52.9297 88.3594H47.0703C31.7775 88.3594 19.3359 100.801 19.3359 116.094C19.3359 118.251 17.5871 120 15.4297 120C13.2723 120 11.5234 118.251 11.5234 116.094C11.5234 96.4932 27.4697 80.5469 47.0703 80.5469H52.9297C72.5303 80.5469 88.4766 96.4932 88.4766 116.094C88.4766 118.251 86.7277 120 84.5703 120Z",
    fill: "#7663EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6094 72.7344C35.0705 72.7344 23.2422 60.9061 23.2422 46.3672C23.2422 31.8283 35.0705 20 49.6094 20C64.1482 20 75.9766 31.8283 75.9766 46.3672C75.9766 60.9061 64.1482 72.7344 49.6094 72.7344ZM49.6094 27.8125C39.3783 27.8125 31.0547 36.1361 31.0547 46.3672C31.0547 56.5982 39.3783 64.9219 49.6094 64.9219C59.8404 64.9219 68.1641 56.5982 68.1641 46.3672C68.1641 36.1361 59.8404 27.8125 49.6094 27.8125Z",
    fill: "#7663EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7109 63.3711H87.4609V52.1211",
    stroke: "#93999F",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.584 55.4159C122.669 53.5007 120.395 51.9815 117.893 50.945C115.39 49.9085 112.708 49.375 110 49.375C107.291 49.375 104.609 49.9085 102.107 50.945C99.6048 51.9815 97.3311 53.5007 95.4159 55.4159L87.4609 63.3709",
    stroke: "#93999F",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.289 76.6289H132.539V87.8789",
    stroke: "#93999F",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4219 84.5839C97.3371 86.4991 99.6108 88.0183 102.113 89.0548C104.615 90.0913 107.297 90.6248 110.006 90.6248C112.714 90.6248 115.396 90.0913 117.899 89.0548C120.401 88.0183 122.675 86.4991 124.59 84.5839L132.545 76.6289",
    stroke: "#93999F",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSubscription);
export default __webpack_public_path__ + "static/media/edit-subscription.0b07dcb6a7cbad7decd961ff496c449a.svg";
export { ForwardRef as ReactComponent };